import { render } from "./ComplianceSuccess.vue?vue&type=template&id=1f65b9ab&scoped=true"
import script from "./ComplianceSuccess.vue?vue&type=script&lang=js"
export * from "./ComplianceSuccess.vue?vue&type=script&lang=js"

import "./ComplianceSuccess.vue?vue&type=style&index=0&id=1f65b9ab&lang=css"
import "./ComplianceSuccess.vue?vue&type=style&index=1&id=1f65b9ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f65b9ab"]])

export default __exports__